import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import KYCHeader from '@/components/KYCHeader';
import { Skeleton } from '@/components/ui/skeleton';

export default function KYCLayout() {
  return (
    <div className="min-h-screen bg-[#F9F9F9] dark:bg-[#1A1A1A]">
      {/* KYC Header */}
      <KYCHeader />

      {/* Page Content */}
      <main className="min-h-screen">
        <Suspense
          fallback={
            <div className="space-y-[1.2rem] p-[2rem]">
              <Skeleton className="h-[3.2rem] w-[16rem]" />
              <Skeleton className="h-[20rem] w-full" />
            </div>
          }
        >
          <Outlet />
        </Suspense>
      </main>
    </div>
  );
}
